import ServiceCatalog from '../../../../components/ServiceCatalog'
export default function BookingDefaultTemplate(props) {return <ServiceCatalog {...props} style="default"/>}
